export const ShopActionTypes = {
    FETCH_COLLECTIONS_START : 'FETCH_COLLECTIONS_START',
    FETCH_COLLECTIONS_SUCCESS : 'FETCH_COLLECTIONS_SUCCESS',
    FETCH_COLLECTIONS_FAILURE : 'FETCH_COLLECTIONS_FAILURE'
}